module.exports = __webpack_public_path__ + "media/pourquoi_donner/group-b687e4e2.png";